import {
   IAvailablePhoneNumber,
   PaginationQueryParams,
   ResponseSuccess,
} from '@forwardflow/types'
import { apiGet } from '../Axios/configs'
import applyPaginationQueryParams from '@forwardflow/helpers/utils/applyPaginationQueryParams'

export default class PhoneNumberService {
   // Get available phone number
   static async getAvailablePhoneNumbers(queryParams: PaginationQueryParams) {
      const data = await apiGet<ResponseSuccess<IAvailablePhoneNumber[]>>({
         apiPath: `/phone-numbers?${applyPaginationQueryParams(queryParams)}`,
      })
      return data.data
   }
}
